import { useEffect, useState } from 'react';

/**
 * The value while it is defined, else the last defined value it had. A modal closing on an undefined
 * prop uses it to keep showing its content while it fades out.
 *
 * @param value - the current value, or undefined while there is none
 * @returns the value, else the last defined one, else undefined
 */
export function useLastDefined<TValue>(value: TValue | undefined): TValue | undefined {
    const [lastDefined, setLastDefined] = useState(value);

    useEffect(() => {
        if (value !== undefined) {
            setLastDefined(value);
        }
    }, [value]);

    return value ?? lastDefined;
}
